import React from 'react';
import loadLogo from '../../../load.svg';

const Os = ( props ) => {

    const [ osList, setOsList ] = React.useState( [] );

    React.useEffect( () => {
    
        fetch( 'https://api.subrataghosh.repl.co/api/v1/os' )
        .then( function( resp ) {
            props.onLoad(80);
            return resp.json(); 
        } )
        .then( function( data ) {
            props.onLoad(100);
            return setOsList( data.items ); 
        } )
        .catch( (e) => console.log( 'Our API service is currently offline' ) );
    
    },[]);

    const osListElements = osList.map( ( data ) => {
        return <div key={data.os} className="skills__sys">{data.os}</div>
    });

    return (
                <div title="OS Skills" className="skills__os">
                    { osList.length === 0 ? 
						<div style={{display:"flex",justifyContent:"center",padding:"50px"}}>
                        	<img title="Loading OS Skills" src={loadLogo} alt="Loading..." style={{width:"50px"}}/>
						</div>
                     : osListElements }
                </div>
    );

}

export default Os;